import React, { useState, useEffect } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Typography, Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { geraStringAleatoria } from "../../utils/geraStringAleatoria";

const useStyles = makeStyles((theme) => ({
  dialogTitle: { background: "#0369a1", color: "#fff", padding: theme.spacing(2) },
  infoBox: { background: "#e0f2fe", border: "1px solid #bae6fd", borderRadius: 8, padding: theme.spacing(1.5), marginBottom: theme.spacing(2) },
  infoText: { fontSize: "0.82rem", color: "#0c4a6e", lineHeight: 1.6 },
}));

const DEFAULT_TEMPLATE =
  "📄 *Fatura {{numero}}*\n" +
  "💰 Valor: R$ {{valor}}\n" +
  "📅 Vencimento: {{vencimento}}\n\n" +
  "💳 *PIX (copia e cola):*\n{{pix}}\n\n" +
  "🔢 *Linha Digitável:*\n{{boleto}}\n\n" +
  "🔗 *2ª via (PDF):* {{link}}";

const DEFAULT = { template: DEFAULT_TEMPLATE };

const FlowBuilderSgpSegundaViaModal = ({ open, onSave, data, onUpdate, close }) => {
  const classes = useStyles();
  const [cfg, setCfg] = useState(DEFAULT);

  useEffect(() => {
    if (open === "edit" && data?.data?.data) {
      setCfg({ template: data.data.data.template || DEFAULT_TEMPLATE });
    } else if (open === "create") {
      setCfg(DEFAULT);
    }
  }, [open, data]);

  const handleSave = () => {
    if (open === "edit") {
      onUpdate(data.id, { data: { label: "2ª Via Faturas SGP", data: cfg } });
    } else {
      onSave({ label: "2ª Via Faturas SGP", data: cfg, id: geraStringAleatoria(30) });
    }
    close();
  };

  return (
    <Dialog open={!!open} onClose={close} fullWidth maxWidth="sm" scroll="paper">
      <DialogTitle className={classes.dialogTitle}>SGP — 2ª Via de Faturas</DialogTitle>
      <DialogContent>
        <Box className={classes.infoBox}>
          <Typography className={classes.infoText}>
            Envia no chat as faturas em aberto do cliente. Usa <strong>sgp_faturas_json</strong>{" "}
            salvo pelo nó "Consultar Cliente". Placeholders disponíveis:{" "}
            <strong>{"{{numero}}"}</strong>, <strong>{"{{valor}}"}</strong>,{" "}
            <strong>{"{{vencimento}}"}</strong>, <strong>{"{{status}}"}</strong>,{" "}
            <strong>{"{{pix}}"}</strong>, <strong>{"{{boleto}}"}</strong>, <strong>{"{{link}}"}</strong>.
          </Typography>
        </Box>

        <TextField
          label="Template da mensagem"
          value={cfg.template}
          onChange={(e) => setCfg({ ...cfg, template: e.target.value })}
          fullWidth multiline rows={10} margin="dense" variant="outlined"
          helperText="Uma mensagem por fatura. Use os placeholders acima."
        />

        <Box style={{ marginTop: 12, padding: 12, background: "#f0f9ff", borderRadius: 8, border: "1px solid #bae6fd" }}>
          <Typography style={{ fontSize: "0.8rem", color: "#0c4a6e", fontWeight: 600, marginBottom: 4 }}>Saídas disponíveis</Typography>
          <Typography style={{ fontSize: "0.8rem", color: "#0369a1" }}>
            🟢 <strong>tem_faturas</strong> — havia faturas e foram enviadas<br />
            🟡 <strong>sem_faturas</strong> — nenhuma fatura em aberto<br />
            🔴 <strong>erro</strong> — falha ao processar
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="secondary">Cancelar</Button>
        <Button onClick={handleSave} color="primary" variant="contained">Salvar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderSgpSegundaViaModal;
